export * from './hospital.service';
export * from './hospital.slice';
